import { computed, inject, Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs';
import { TokenClaims } from '@spe-content-store/interfaces';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private readonly oidcSecurityService = inject(OidcSecurityService);
    private readonly userData = this.oidcSecurityService.userData;

    public readonly isAuthenticated = computed(() => this.oidcSecurityService.authenticated().isAuthenticated);
    public readonly userIdTokenClaims = computed(() => (this.userData().userData as TokenClaims | null) ?? null);
    public readonly userPhoto = computed(() => this.userIdTokenClaims()?.picture ?? '');
    public readonly userEmail = computed(() => {
        const claims = this.userIdTokenClaims();
        return claims?.email ?? claims?.mail ?? '';
    });
    public readonly userName = computed(() => {
        const claims = this.userIdTokenClaims();
        if (!claims) {
            return '';
        }

        const givenName = claims.preferred_given_name ?? claims.given_name;
        const familyName = claims.preferred_family_name ?? claims.family_name;
        if (givenName && familyName) {
            return `${familyName}, ${givenName}`;
        }

        return claims.display_name ?? claims.name ?? claims.preferred_username ?? claims.email ?? '';
    });

    public login(): void {
        this.oidcSecurityService.authorize();
    }

    public logout(): void {
        this.oidcSecurityService.logoff().pipe(take(1)).subscribe();
    }
}
